type FileConfigProps = {
  label: string;
  type: string;
  name: string;
  maxFiles: number;
  showOrder: boolean;
  isImage?: boolean;
  deleteButtonDescription: string;
  uploadIconName: string;
  uploadTextDescription: string;
  value?: string;
  allowedFileType: string;
  attachmentTypeConfig?: AttachmentTypeConfigProps;
};

type AttachmentTypeConfigProps = {
  options: Array<{ key: string; text: string }>;
};

export enum AttachmentTypes {
  DOCUMENT = "document",
  CONTRACT_ACTIVATION_FEE_PROOF = "contractActivationFeeProof",
  SELFIE = "selfie",
  SHIPPING_ADDRESS = "shippingAddress",
  LOYALTY_CHECK = "loyaltyCheck",
  CHIP = "chip"
}

export const attachmentTypeToLabel: Record<AttachmentTypes, string> = {
  [AttachmentTypes.DOCUMENT]: "RG/CNH",
  [AttachmentTypes.CONTRACT_ACTIVATION_FEE_PROOF]: "Comprovante de Adesão",
  [AttachmentTypes.SELFIE]: "Selfie",
  [AttachmentTypes.SHIPPING_ADDRESS]: "Endereço de envio",
  [AttachmentTypes.LOYALTY_CHECK]: "Consulta de Fidelidade",
  [AttachmentTypes.CHIP]: "Chip"
} as const;

const attachmentTypeConfigOptions = () => {
  const allowedFileTypesForUpload = [
    AttachmentTypes.DOCUMENT,
    AttachmentTypes.CONTRACT_ACTIVATION_FEE_PROOF,
    AttachmentTypes.SHIPPING_ADDRESS,
    AttachmentTypes.LOYALTY_CHECK,
    AttachmentTypes.CHIP
  ];

  return allowedFileTypesForUpload.map(type => {
    const label = attachmentTypeToLabel[type];

    return { key: type, text: label };
  });
};

export const fields = {
  get uploadDocument(): Array<FileConfigProps> {
    return [
      {
        label: "Documentos",
        type: "files",
        maxFiles: 10,
        showOrder: false,
        deleteButtonDescription: "Apagar Documento da lista",
        uploadIconName: "CloudUpload",
        uploadTextDescription: "Selecione os arquivos ou arraste-os aqui",
        allowedFileType: "image/*,application/pdf,text/plain",
        name: "files",
        value: "",
        attachmentTypeConfig: {
          options: attachmentTypeConfigOptions()
        }
      }
    ];
  }
};
